import graphqlClient from "../utils/graphql_client_util";

const MUTATIONS = {
  SEND_SMS_VERIFICATION: `
    mutation SendVerification($input: SendSmsVerificationInput!) {
      sendVerification(input: $input) {
        success
        error {
          message
          errorType
          code
        }
        data {
          verificationCode
          smsVerificationHistorySeq
          regDate
          phoneNumber
          isVerified
          expiresAt
        }
      }
    }
  `,

  VERIFY_PHONE_CODE: `
    mutation ConfirmVerification($input: ConfirmVerificationInput!) {
      confirmVerification(input: $input) {
        success
        error {
          message
          errorType
          code
        }
        data {
          userSeq
          refreshToken
          accessToken
        }
      }
    }
  `,
};

export const requestPhoneAuth = async (phone_number) => {
  try {
    const data = await graphqlClient.mutation(
      MUTATIONS.SEND_SMS_VERIFICATION,
      {
        input: { phoneNumber: phone_number },
      },
      { useAuth: false }
    );

    if (data.sendVerification.success) {
      return {
        success: true,
        data: data.sendVerification.data,
      };
    } else {
      return {
        success: false,
        error: data.sendVerification.error,
      };
    }
  } catch (err) {
    console.error(err);

    return {};
  }
};

export const verifyPhoneCode = async (phone_number, verification_code) => {
  try {
    const data = await graphqlClient.mutation(
      MUTATIONS.VERIFY_PHONE_CODE,
      {
        input: {
          phoneNumber: phone_number,
          verificationCode: verification_code,
        },
      },
      { useAuth: false }
    );

    if (data.confirmVerification.success) {
      return {
        success: true,
        data: data.confirmVerification.data,
      };
    } else {
      return {
        success: false,
        error: data.confirmVerification.error,
      };
    }
  } catch (err) {
    console.error(err);

    return {};
  }
};
